import React from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import { ethers } from 'ethers';
import BigNumber from 'bignumber.js';

import { withStyles } from '@material-ui/core/styles';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableRow from '@material-ui/core/TableRow';

import HoverLink from 'components/HoverLink';

const styles = theme => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  edit: {
    fontSize: 'medium',
  },
  buttonMatch: {
    color: theme.palette.primary.success,
  },
  expandedRow: {
    backgroundColor: '#f3f3f3',
  },
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
  buttonCell: {
    whiteSpace: 'nowrap',
  },
  totalsTable: {
    marginTop: '1rem',
  },
  totalsCell: {
    border: 0,
    fontWeight: 'bold',
  },
});

const Details = styled.div`
  font-size: 11px;
  color: #444;
`;

const Row = props => {
  const { classes, row } = props;

  const stripeConnectUrlPrefix = `https://dashboard.stripe.com/connect`;

  const stripeAccountIdCell = !row.stripe_account_id ? null : (
    <HoverLink href={`${stripeConnectUrlPrefix}/accounts/${row.stripe_account_id}`} alt="Stripe Account">
      {row.stripe_account_id}
    </HoverLink>
  );

  const statusCell = 'Ready for Transfer';

  let amountCell;
  if (row.external_transfer_method === 'Stripe') {
    const netUSD = new BigNumber(row.sum_post_recoup_usd).minus(new BigNumber(row.deducted_fee_amount || 0)).toString();
    amountCell = (
      <div
        title={`Transfer: $${row.transferred_amount || 'N/A'}
Escrow: $${row.untransferred_amount || 'N/A'}
Post Recoup: $${row.sum_post_recoup_usd}
Stripe Fee: $${row.deducted_fee_amount}
Net Amount: $${netUSD}`}>
        {numeral(netUSD).format('$0,0.00')}{' '}
      </div>
    );
  } else if (row.external_transfer_method === 'Ethereum') {
    // TODO: pick up ethereum wei amount
    // TODO: display net amount after gas fee
    const format = n => (n ? '⬘' + numeral(ethers.utils.formatEther(n.toString())).format('0,0.0000') : 'N/A');
    amountCell = (
      <div
        title={`Transfer: ${format(row.transferred_amount)}
Escrow: ${format(row.untransferred_amount)}
Amount: ${format(row.sum_post_recoup_usd)}`}>
        {format(row.sum_post_recoup_usd)}{' '}
      </div>
    );
  }

  return (
    <MuiTableRow className={classes.root}>
      <MuiTableCell component="th" scope="row">
        {row.id}
      </MuiTableCell>
      <MuiTableCell>{row.user_group_type}</MuiTableCell>
      <MuiTableCell>
        <div>{row.user_group_name}</div>
        <Details>{row.account_email}</Details>
        <Details>{stripeAccountIdCell}</Details>
      </MuiTableCell>
      <MuiTableCell>{row.external_transfer_method}</MuiTableCell>
      <MuiTableCell align="right">{amountCell}</MuiTableCell>
      <MuiTableCell align="right">{statusCell}</MuiTableCell>
    </MuiTableRow>
  );
};

export default withStyles(styles)(Row);
